import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ToastService } from '../services';
import { SubmitResponse } from '../models';

@Injectable()
export class GlobalResponseInterceptor implements HttpInterceptor {
  constructor(private messageService: ToastService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if the request is a DELETE, PUT, or POST
    if (['DELETE', 'PUT', 'POST'].includes(req.method)) {
      return next.handle(req).pipe(
        tap({
          next: (event) => {
            if (event instanceof HttpResponse) {
              if (event.url.includes('login')) {
                return;
              }
              // Display a success message based on the method
              if (event.body) {
                this.displayResponse(event.body);
              } else {
                this.displayMessage(req.method, true);
              }
            }
          }
        })
      );
    }

    // Pass through for other HTTP methods
    return next.handle(req);
  }

  private displayMessage(method: string, success: boolean): void {
    const action = method === 'DELETE' ? 'delete' : method === 'PUT' ? 'update' : 'create';
    const message = success ? `Successfully ${action}d the resource.` : `Failed to ${action} the resource.`;

    if (success) {
      this.messageService.success(message);
    } else {
      this.messageService.error(message);
    }
  }

  private displayResponse(body: SubmitResponse): void {
    if (body.status === 'success') {
      this.messageService.success(body.message);
    } else {
      this.messageService.error(body.message);
    }
  }
}
